__turbopack_context__.v({
  "avatar": "compact-review-slider-module__ZZM7XW__avatar",
  "avatarButton": "compact-review-slider-module__ZZM7XW__avatarButton",
  "avatarFallback": "compact-review-slider-module__ZZM7XW__avatarFallback",
  "content": "compact-review-slider-module__ZZM7XW__content",
  "dot": "compact-review-slider-module__ZZM7XW__dot",
  "dotActive": "compact-review-slider-module__ZZM7XW__dotActive",
  "meta": "compact-review-slider-module__ZZM7XW__meta",
  "navButton": "compact-review-slider-module__ZZM7XW__navButton",
  "navigation": "compact-review-slider-module__ZZM7XW__navigation",
  "navigationDots": "compact-review-slider-module__ZZM7XW__navigationDots",
  "rating": "compact-review-slider-module__ZZM7XW__rating",
  "review": "compact-review-slider-module__ZZM7XW__review",
  "reviewText": "compact-review-slider-module__ZZM7XW__reviewText",
  "reviewerName": "compact-review-slider-module__ZZM7XW__reviewerName",
  "slide": "compact-review-slider-module__ZZM7XW__slide",
  "slider": "compact-review-slider-module__ZZM7XW__slider",
  "starEmpty": "compact-review-slider-module__ZZM7XW__starEmpty",
  "starFilled": "compact-review-slider-module__ZZM7XW__starFilled",
  "track": "compact-review-slider-module__ZZM7XW__track",
  "trackDragging": "compact-review-slider-module__ZZM7XW__trackDragging",
  "viewAllReviewsLink": "compact-review-slider-module__ZZM7XW__viewAllReviewsLink",
  "viewport": "compact-review-slider-module__ZZM7XW__viewport",
  "wrapper": "compact-review-slider-module__ZZM7XW__wrapper",
});
